module.exports = __webpack_public_path__ + "img/jordskredaktsomhet.abcf0b08.jpg";